import React, { useState } from 'react';
import GuideViewer from '../guide/GuideViewer';
import MediaBrowser from '../media/MediaBrowser';
import WebGames from '../games/WebGames';
import QuestBoard from '../quests/QuestBoard';
import SnackMenu from '../snacks/SnackMenu';
import { PosterWall } from '../posters/Posters';
import POSTERS from '../posters/posters.json';
import { ArtWall } from '../artwall/ArtWall';
import PAINTINGS from '../artwall/paintings.json';
import { pickRandom } from '../lib/random';
import DebugPanel from '../debug/DebugPanel';
import { isDebugMode } from '../debug/debugLog';
import MusicPlayer from './MusicPlayer';
import LocalClock from './LocalClock';
import OnThisDay from './OnThisDay';
import SidebarNav from './SidebarNav';
import Ticker from './Ticker';
import WorldClock from './WorldClock';
import { TICKER_MESSAGE } from './tickerMessage';
import './splash.css';

function SplashPage() {
  // one poster for the wall, a new one each visit
  const [poster] = useState(() => pickRandom(POSTERS, 1)[0]);
  // and one painting for the gallery along the bottom
  // military (24-hour) time is the default; the toggle in the header switches every clock on the page
  const [military, setMilitary] = useState(true);
  const [painting] = useState(() => pickRandom(PAINTINGS, 1)[0]);

  return (
    <div className="ms-page fm-page" id="top">
      <Ticker message={TICKER_MESSAGE} />

      <header className="fm-header">
        <img className="fm-logo-img" src="/favicon.svg" alt="" width="72" height="72" />
        <div className="fm-header-text">
          <h1 className="ms-title">hello world!</h1>
          <p className="ms-subtitle">welcome to nicole.click</p>
          <p className="fm-tagline">a place to visit and listen</p>
        </div>
        <WorldClock military={military} onChangeMilitary={setMilitary} />
      </header>

      <div className="fm-layout">
        <aside className="fm-side">
          <SidebarNav />
          <OnThisDay />
        </aside>

        <main className="fm-main">
          <section id="player" className="ms-box fm-wide" aria-labelledby="player-title">
            <h2 className="ms-box-title fm-title-bar" id="player-title">
              <span>♪ Now Playing</span>
              <LocalClock military={military} />
            </h2>
            <div className="ms-box-body">
              <MusicPlayer />
            </div>
          </section>

          <div className="fm-pair fm-quad fm-wide">
            <section id="games" className="ms-box" aria-labelledby="games-title">
              <h2 className="ms-box-title" id="games-title">🕹️ Web Games</h2>
              <div className="ms-box-body">
                <WebGames />
              </div>
            </section>
            <section id="snacks" className="ms-box" aria-labelledby="snacks-title">
              <h2 className="ms-box-title" id="snacks-title">🍽️ Snack Menu</h2>
              <div className="ms-box-body">
                <SnackMenu />
              </div>
            </section>
            <section id="guide" className="ms-box" aria-labelledby="guide-title">
              <h2 className="ms-box-title" id="guide-title">📖 Hitchhiker's Guide to Nicole</h2>
              <div className="ms-box-body">
                <GuideViewer />
              </div>
            </section>
            <section id="movies" className="ms-box" aria-labelledby="movies-title">
              <h2 className="ms-box-title" id="movies-title">🎬 Movie Night</h2>
              <div className="ms-box-body">
                <MediaBrowser />
              </div>
            </section>
          </div>

          <section id="quests" className="ms-box fm-wide" aria-labelledby="quests-title">
            <h2 className="ms-box-title" id="quests-title">🗺️ Quest Board</h2>
            <div className="ms-box-body">
              <QuestBoard />
            </div>
          </section>

          <section id="posters" className="ms-box fm-wide" aria-labelledby="posters-title">
            <h2 className="ms-box-title" id="posters-title">🖼️ Poster Wall</h2>
            <div className="ms-box-body">
              <PosterWall poster={poster} />
            </div>
          </section>

          {isDebugMode() && <DebugPanel />}
        </main>
      </div>

      <section id="art" className="ms-box fm-art-wall" aria-labelledby="art-title">
        <h2 className="ms-box-title" id="art-title">🎨 Art Gallery</h2>
        <div className="ms-box-body">
          <ArtWall painting={painting} />
        </div>
      </section>

      <footer className="fm-footer">best viewed in any browser ♥ made by nicole</footer>
    </div>
  );
}

export default SplashPage;
